import React, { Component } from 'react'
import PropTypes from 'prop-types'
import RBButton from '../../controls/RBButton'
import { localizeImg, localize } from '../../util/Localizer'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { intlShape, FormattedMessage } from 'react-intl'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import { Dimensions } from '../../theme'

class RetrievePassword extends Component {
  constructor () {
    super()
    this.backToLogin = this.backToLogin.bind(this)
  }

  backToLogin (e) {
    e.preventDefault()
    this.context.router.history.push('/')
  }

  render () {
    const { classes = {} } = this.props
    const logo = localizeImg('/img/logo.svg')
    return (
      <div className={classes.retrievePass}>
        <Grid fluid>
          <Row center='lg' className={classes.screenHeight}>
            <Col xs={12} md={4} lg={6} id='login'>
              <Paper className={classes.paper} elevation={2}>
                <div>
                  <img src={logo} alt={localize('pages.login.logoAlt')} />
                  <div>
                    <h2><FormattedMessage id='pages.RetrievePassword.header' /></h2>
                    <p><FormattedMessage id='pages.RetrievePassword.message' /></p>
                  </div>
                  <div className='centered' id='login-form'>
                    <RBButton label={localize('pages.RetrievePassword.backButton')} onClick={this.backToLogin} fullWidth primary variant='contained' />
                  </div>
                </div>
              </Paper>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

RetrievePassword.contextTypes = {
  intl: intlShape.isRequired,
  router: PropTypes.object
}

const styles = {
  retrievePass: {
    '& img': {
      maxWidth: Dimensions.loginLogoMaxWidth
    },
    '& p': {
      marginBottom: 85
    }
  },
  paper: {
    width: '100%',
    padding: '45px 100px',
    textAlign: 'center',
    display: 'inline-block'
  },
  screenHeight: {
    minHeight: 'calc(100vh)'
  }
}

export default withStyles(styles)(RetrievePassword)



// WEBPACK FOOTER //
// ./src/widgets/ForgotPassword/RetrievePassword.js